import { BaseQuery, QueryConfig, QueryResponse, QueryResult } from "@/shared/types/base";
import { Deposito } from "@/shared/types/deposito";
import { removeNullOrEmptyKeys, sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";

export interface DepositosQuery extends BaseQuery {
    nombre?: string,
}

export async function getAllDepositos(query?: DepositosQuery): Promise<QueryResponse<Deposito>> {
    await sleep(1000);
    const response = await api.get("depositos", { params: removeNullOrEmptyKeys(query) });
    return response.data;
}

export function useGetAllDepositosQuery(query: DepositosQuery = {}, queryConfig: QueryConfig<QueryResponse<Deposito>> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getAllDepositos(query),
        queryKey: ["depositos", query],
    })
}

export interface GetAllDepositoQueryProps {
    query?: DepositosQuery,
    queryConfig?: QueryConfig<QueryResponse<Deposito>>,
    children: (queryResult: QueryResult<QueryResponse<Deposito>>) => ReactNode
}

export function GetAllDepositosQuery({
    query,
    queryConfig,
    children
}: GetAllDepositoQueryProps) {
    const queryResult = useGetAllDepositosQuery(query, queryConfig);
    return children && children(queryResult);
}
